import React from 'react';
import { Link } from 'gatsby';

import SEO from '../../components/seo';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

import plantFacility from '../../images/kalinga/plant-facility.jpeg';

import '../../components/layout.css';

const ProjectsPage = () => (
  <div className="theme-default bg-background text-foreground">
    <SEO title="Projects" />
    <Header />

    <main>
      {/* OCF secondaryHero: chip + h1 */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <span className="chip mb-6 inline-flex">Our work</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight tracking-tight mt-4">
            Projects
          </h1>
        </div>
      </section>

      <div className="h-20 md:h-32" />

      {/* OCF twoUpLabelAndText */}
      <section className="section">
        <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
            <div className="md:col-span-4 md:col-start-1">
              <span className="chip">Active programme</span>
            </div>
            <div className="md:col-span-8 md:col-start-5">
              <div className="bg-background-raised rounded border border-border overflow-hidden">
                <img
                  src={plantFacility}
                  alt="Pyrolysis facility exterior"
                  className="w-full h-64 object-cover"
                />
                <div className="p-8">
                  <h3 className="text-2xl md:text-3xl font-light tracking-tight mb-4">
                    Project Kalinga
                  </h3>
                  <p className="text-base leading-relaxed mb-6">
                    Operational biochar programme in Odisha, India. Controlled
                    slow pyrolysis of 100% rice husk into stable biochar for
                    permanent soil carbon storage. Two facilities in Kalahandi
                    and Sambalpur districts.
                  </p>
                  <Link to="/projects/kalinga" className="button-split group">
                    <span className="button-split-circle">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M13 7l5 5m0 0l-5 5m5-5H6"
                        />
                      </svg>
                    </span>
                    <span className="button-split-pill">
                      View Project Kalinga
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default ProjectsPage;
